import React from 'react';
import { FiSave } from 'react-icons/fi';

const SaveIcon = () => {
  return <FiSave />;
};

export default SaveIcon;
